// extracted by mini-css-extract-plugin
export default {"addToCartControl":"LZ-z","giftCard":"MZ-z","btnContainer":"NZ-z","cartButton":"OZ-z","disabled":"PZ-z"};